import axios from "axios";
import {detailServicesPath} from "../../../Constants";

const detailControllerRestUrl = detailServicesPath + '/customers/orders/'

export default class EdgesControllerService {
    static async getAll(orderId) {
        return axios.get(`${detailControllerRestUrl}${orderId}/edges`);
    }

    static async save(orderId, data) {
        const params = orderId === 0 ? "?sample=true" : ""
        return await axios.post(`${detailControllerRestUrl}${orderId}/edges${params}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async applyToSide(orderId, detailId, sides, orderEdgeId) {
        return await axios.post(`${detailControllerRestUrl}${orderId}/edges/sides?detailId=${detailId}?sides=${sides}?orderEdgeId=${orderEdgeId}`, JSON.stringify({}), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(orderId, edgeId) {
        const params = orderId === 0 ? "?sample=true" : ""
        return await axios.delete(`${detailControllerRestUrl}${orderId}/edges/${edgeId}${params}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async edit(orderId, edgeId, data) {
        const params = orderId === 0 ? "?sample=true" : ""
        return await axios.put(`${detailControllerRestUrl}${orderId}/edges/${edgeId}${params}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}
